import { Injectable } from "@angular/core";
import { ApplicationHttpService } from "../../../core/services/application-http.service";
import { map, Observable, of, retry, Subject } from "rxjs";
import SockJS from "sockjs-client";
import { Client, IMessage } from "@stomp/stompjs";
import { NotificationRequest } from "../models/notification-request.model";
import { Notification } from "../models/notification.model";
import { NotificationResponse } from "../models/notification-response.model";
import { StorageService } from "../../../public/services/storage.service";
import { environment } from "../../../../environments/environment";

@Injectable()
export class NotificationService {
    //@ts-ignore
    token: string;
    //@ts-ignore
    userId: string;
    isConnected: boolean = false;
    public count: number = 0;

    public updateCount$ = new Subject<number>();

    //@ts-ignore
    private client: Client;
    private readonly url = `${environment.wsEndpoint}`;

    constructor(
        private storageService: StorageService, 
        private http: ApplicationHttpService) {}
    //@ts-ignore
    receiptId: string;

    //@ts-ignore
    selectedItem: Notification;
    public showNotificationModal$ = new Subject<number>();
    public showNotificationContent$ = new Subject<number>();

    connect() {
        this.token = this.storageService.getToken()!;
        this.userId = this.storageService.getUser()?.sub;

        this.client = new Client({
            webSocketFactory: () => new SockJS(this.url),
            connectHeaders: {
                Authorization: `Bearer ${this.token}`
            },
            reconnectDelay: 5000,
            onConnect: () => {
                this.isConnected = true;
                this.connectToTopicCount();
            },
            onDisconnect: () => {
                this.isConnected = false;
            },
            onStompError: () => {
                this.isConnected = false;
            },
            onWebSocketError: (error: string) => {
                console.error(error);
            },
            debug: () => {},
        });

        this.client.activate();
    }

    connectToTopicCount() {
        this.client.subscribe(`/user/${this.userId}/queue/notifications/count`, this.onMessageReceived);
        this.notificationCount().subscribe(count => {
            this.count = count;
            this.updateCount$.next(count);
        })
    }

    onMessageReceived = (message: IMessage) => {
        const body = JSON.parse(message.body);
        this.count = body;
        this.updateCount$.next(body);
    };

    notifications(request?: NotificationRequest): Observable<NotificationResponse> {
        return this.http.post(`user-notification/load${request?.getUrl()}`, null);
    }

    notificationCount(): Observable<any> {
        return this.http.get(`user-notification/count`);
    }

    setIsRead(id: number): Observable<any> {
        return this.http.put(`user-notification/set-status-seen/${id}`, null);
    }

    setIsReadAll(): Observable<any> {
        return this.http.put(`user-notification/set-status-seen/all`, null);
    }
}